// extracted by mini-css-extract-plugin
export var callCostTableEnabledCell = "call-cost-table__enabled-cell_Nua2rEZFrtkXekIgX7Bm";